export enum EnumCargaTipo {
    PRONTO = 0,
    ADICIONAR = 1,
    ATUALIZAR = 2,
    REJEITADO = 3,
    ANALISANDO = 4,
    FALHA = 5,
    SEM_ALTERACOES = 6
}